export default {
  name: 'add-more-item',
  components: {},
  props: [],
  data () {
    return {
      items: [],
      check_all: false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    show (items) {
      this.check_all = false
      this.items = items
      this.$refs.addMoreItemModal.show()
    },
    hide () {
      this.$refs.addMoreItemModal.hide()
    },
    checkAll () {
      this.items.forEach(element => {
        element.select = this.check_all
      })
    },
    save () {
      var items = []
      this.items.forEach(element => {
        if (element.select) {
          items.push(element)
        }
      })
      this.$emit('addItemSuccess', items)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/checklist-item/table-item/add-more-item/add-more-item.js